export enum Balance {
  Trading,
  Staking,
}

export type TradeInputVariant = 'singleTrade' | 'multiTrade';
